import React, { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";
import { Html5Qrcode } from "html5-qrcode";
import axios from "axios";
import { BASE_URL } from "../Apis/apiConfig";

export default function QRScaner({ width = 360, height = 360 }) {
  const readerId = "qr-reader-cam";
  const canvasRef = useRef(null);
  const html5Ref = useRef(null);
  const startedRef = useRef(false);

  const [mode, setMode] = useState("show");
  const [error, setError] = useState("");

  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  const societyFromStorage = localStorage.getItem("society");
  const BASE_QR_URL = "https://your-second-project.com/scan-result";


  useEffect(() => {
    if (mode !== "show" || !selectedEmployee) return;

    const canvas = canvasRef.current;
    if (!canvas) return;

    const url = new URL(BASE_QR_URL);
    url.searchParams.set("phone", selectedEmployee.employeePhone);
    url.searchParams.set(
      "society",
      selectedEmployee.societyName || societyFromStorage
    );

    QRCode.toCanvas(canvas, url.toString(), {
      width: Math.min(280, width - 20),
    }).catch(() => setError("Failed to generate QR"));
  }, [mode, selectedEmployee, width]);

  
  useEffect(() => {
    if (mode !== "scan") return;

    Html5Qrcode.getCameras().then((cams) => {
      if (!cams.length) {
        setError("No camera found");
        return;
      }

      const html5 = new Html5Qrcode(readerId);
      html5Ref.current = html5;

      html5.start(
        { deviceId: { exact: cams[0].id } },
        { fps: 10, qrbox: 260 },
        async (decodedText) => {
          await html5.stop();
          await html5.clear();
          window.location.href = decodedText;
        }
      );

      startedRef.current = true;
    });

    return () => {
      if (html5Ref.current && startedRef.current) {
        html5Ref.current.stop();
        html5Ref.current.clear();
      }
    };
  }, [mode]);


  useEffect(() => {
    const token = localStorage.getItem("token");
    const societyName = localStorage.getItem("society");

    axios
      .get(`${BASE_URL}/api/employee/get-all-services-by-security-guard`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { societyName },
      })
      .then((res) => {
        setEmployees(res.data || []);
        setSelectedEmployee(res.data?.[0] || null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div style={{ width }}>
      <canvas ref={canvasRef} />
      <br />
      <select
        style={{ width: "100%", padding: 8 }}
        value={selectedEmployee?.employeeId || ""}
        onChange={(e) =>
          setSelectedEmployee(
            employees.find(
              (emp) => emp.employeeId === Number(e.target.value)
            )
          )
        }
      >
        {employees.map((emp) => (
          <option key={emp.employeeId} value={emp.employeeId}>
            {emp.employeeName} — Gate {emp.gateNumber ?? "N/A"}
          </option>
        ))}
      </select>

      <button
        style={{
          marginTop: 10,
          width: "100%",
          padding: 10,
          background: "#007bff",
          color: "#fff",
          border: "none",
        }}
        onClick={() => setMode(mode === "show" ? "scan" : "show")}
      >
        {mode === "show" ? "Scan QR" : "Show QR"}
      </button>

      {mode === "scan" && <div id={readerId} />}
    </div>
  );
}
